export const getDate = (date: Date | string) => {
  if (!date) {
    return "";
  }

  const localDate = new Date(date);
  const day = localDate.getDate();
  const preparedDay = day.toString().padStart(2, "0");
  const month = localDate.getMonth() + 1;
  const preparedMonth = month.toString().padStart(2, "0");
  const year = localDate.getFullYear();
  return `${preparedDay}.${preparedMonth}.${year}`;
};

export const getRoutePath = (path: string, locale: string) => {
  return path.replace(`/${locale}`, "");
};